import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const SupportersList = ({ token, clientUuid , onClose }) => {
    const navigate = useNavigate();
    const [clientUserName,setClientUserName] = useState('');
    const [supporters, setSupporters] = useState([]);

    useEffect(() => {
        const fetchSupporters = async () => {
            try {
                const response = await axios.get(`/users/${clientUuid}/supporters`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const interface_supporters = response.data.data.supporters;
                
                setSupporters(interface_supporters);

            } catch (error) {
                alert('회원 정보를 가져오는데 실패했습니다');
            }
        };

        const fetchAccountInfo = async () => {
            try {
                const response = await axios.get(`/users/${clientUuid}/accountinfo`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const data = response.data.data;
                setClientUserName(data.username);

            } catch (error) {
                alert('회원 정보를 가져오는데 실패했습니다');
            }
        };

        fetchSupporters();
        fetchAccountInfo();
    }, [token]);

    return (
        <div className="supporters-list">
            <h3>
                {supporters.length > 0
                    ? (<div>{clientUserName}님의<br></br>
                    해돋이를 기다리는 사람들</div>)
                    : (<div>아직 아무도 지원하지 않았어요</div>)}
            </h3>
            {/* <button onClick={onClose}>닫기</button> */}
            {supporters.map((supporter, index) => {
                const uuid = supporter?.uuid || '';
                const username = supporter?.username || "알 수 없는 사용자";
                const gaugeRaised = supporter?.gaugeRaised || 0;
                

                return (
                    <div key={index} className="supporter-card">
                        <p>
                            {username}님의 바램으로 해가 {gaugeRaised} 해돋이 올라갔어요!
                        </p>
                        <button onClick={() => {
                            navigate(`/userSun/${uuid}`)
                            onClose()
                            }}>
                            보답하기
                        </button>
                    </div>
                );
            })}
        </div>
    );
};

export default SupportersList;
